import { Component, OnInit } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { LoginRequest } from './core/interfaces/usuario';
import { AuthService } from './core/services/auth.service';
import { SwUpdate } from '@angular/service-worker';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AtualizacoesDoSistemaComponent } from './core/shared/components/modais/atualizacoes-do-sistema/atualizacoes-do-sistema.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'Nova Tela Azul';
  version = environment.version;
  login: LoginRequest = {
    login: '',
    senha: ''
  };
  isLoading = false;

  constructor(
    private swUpdate: SwUpdate,
    protected router: Router,
    private ngbModal: NgbModal,
  ) { }


  ngOnInit(): void {
    this.router.events.pipe(filter(e => e instanceof NavigationStart)).subscribe(e => {
      this.isLoading = true;
    });
    this.router.events.pipe(filter(e => (e instanceof NavigationEnd || e instanceof NavigationCancel || e instanceof NavigationError))).subscribe(e => {
      this.isLoading = false;
    });
    this.verificarAtualizacao();
  }

  verificarAtualizacao() {
    if (environment.production) {
      this.swUpdate.checkForUpdate().then((event) => {
        if (event) {
          this.ngbModal.open(AtualizacoesDoSistemaComponent);
        }
      });
    }
  }

  async verifyUserLogged() {
    const userLocal: any = await localStorage.getItem('last_login_user');
  }
}
